// Relative-time formatter shared by Employee Tracking's card/table views.
export const timeAgo = (ts) => {
    if (!ts) return null;
    const diff = Math.floor((Date.now() - new Date(ts)) / 1000);
    if (diff < 60)    return `${diff}s ago`;
    if (diff < 3600)  return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return new Date(ts).toLocaleDateString();
};

// "Today, 7:00 PM" / "Yesterday, 6:45 PM" / "21 Aug 2026, 6:45 PM" — shared
// by the notification bell/dropdown and Notification Center so both read
// the same way instead of each rolling its own Date formatting.
export const smartDateTime = (ts) => {
    if (!ts) return '';
    const date = new Date(ts);
    const now = new Date();
    const time = date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });

    const isSameDay = (a, b) =>
        a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

    if (isSameDay(date, now)) return `Today, ${time}`;

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (isSameDay(date, yesterday)) return `Yesterday, ${time}`;

    const dateStr = date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
    return `${dateStr}, ${time}`;
};
